// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GOUAE","col":"styles_col__3HRS1"};